import {
  CClassEavTargetValuesEnum,
  CClassesKey,
  CClassUoTargetValuesEnum,
  CCustomClassData,
  CustomClassData,
  PClassEavTargetValuesEnum,
  PClassEminTargetValuesEnum,
  PClassesKey,
  PCustomClassData,
} from "types";

export type BorderTargetValues = {
  eavTargetValue: string | number;
  eminTargetValue: string | number;
  uoTargetValue: string | number;
};

export function getBorderAreaTargetValues(
  borderAreaClass: CClassesKey | PClassesKey,
  customBorderClass: CustomClassData | undefined | null
): BorderTargetValues {
  let eavTargetValue: string | number = "";
  let eminTargetValue: string | number = "";
  let uoTargetValue: string | number = "";

  if (borderAreaClass?.includes("C")) {
    // @ts-ignore
    eavTargetValue = CClassEavTargetValuesEnum[borderAreaClass as keyof typeof CClassEavTargetValuesEnum];
    // @ts-ignore
    uoTargetValue = CClassUoTargetValuesEnum[borderAreaClass as keyof typeof CClassUoTargetValuesEnum];
  } else if (borderAreaClass?.includes("P")) {
    // @ts-ignore
    eavTargetValue = PClassEavTargetValuesEnum[borderAreaClass as keyof typeof PClassEavTargetValuesEnum];
    // @ts-ignore
    eminTargetValue = PClassEminTargetValuesEnum[borderAreaClass as keyof typeof PClassEminTargetValuesEnum];
  }

  if (customBorderClass?.class_type?.includes("C")) {
    eavTargetValue = (customBorderClass as CCustomClassData).Em_av ?? eavTargetValue;
    eminTargetValue = "";
    uoTargetValue = (customBorderClass as CCustomClassData).E_uo ?? uoTargetValue;
  } else if (customBorderClass?.class_type?.includes("P")) {
    eavTargetValue = (customBorderClass as PCustomClassData).Em_av ?? eavTargetValue;
    eminTargetValue = (customBorderClass as PCustomClassData).Em_min ?? eminTargetValue;
    uoTargetValue = "";
  }

  return { eavTargetValue, eminTargetValue, uoTargetValue };
}
